import { GudHubHttpsService } from "./gudhub-https-service.js";
import { PipeService } from "./PipeService/PipeService.js";
import { Storage } from "./Storage/Storage.js";
import { WebSocketApi } from "./WebSocket/WebSocket.js";
import { wss_url, server_url, async_modules_path, file_server_url, automation_modules_path } from "./config.js";
import { Utils } from "./Utils/Utils.js";
import { Auth } from "./Auth/Auth.js";
import { GHConstructor } from "./GHConstructor/ghconstructor.js";
import { AppProcessor } from "./AppProcessor/AppProcessor.js";
import { ItemProcessor } from "./ItemProcessor/ItemProcessor.js";
import { FieldProcessor } from "./FieldProcessor/FieldProcessor.js";
import { FileManager } from "./FileManager/FileManager.js";
import { ChunksManager } from "./ChunksManager/ChunksManager.js";
import { DocumentManager } from "./DocumentManager/DocumentManager.js";
import { Interpritate } from './GHConstructor/interpritate.js'
import { IS_WEB } from "./consts.js";
import { WebsocketHandler } from './WebSocket/WebsocketHandler.js';
import { GroupSharing } from './Utils/sharing/GroupSharing.js';
import { Sharing } from './Utils/sharing/Sharing.js';
import { WebSocketEmitter } from './WebSocket/WebSocketEmitter.js';

export class GudHub {
  constructor(
    authKey,
    options = {
      server_url,
      wss_url,
      initWebsocket: false,
      activateSW: false,
      swLink: "",
      async_modules_path,
      file_server_url,
      automation_modules_path
    }
  ) {
    this.ghconstructor = new GHConstructor(this);
    this.interpritate = new Interpritate(this);
    this.pipeService = new PipeService();
    this.storage = new Storage(options.async_modules_path, options.file_server_url, options.automation_modules_path);
    this.util = new Utils(this);
    this.req = new GudHubHttpsService(options.server_url);
    this.auth = new Auth(this.req, this.storage);
    this.sharing = new Sharing(this, this.req);
    this.groupSharing = new GroupSharing(this, this.req, this.pipeService);
    if (authKey) this.storage.setUser({ auth_key: authKey });
    this.req.init(this.auth.getToken.bind(this.auth));

    this.ws = new WebSocketApi(options.wss_url, this.auth);
    this.chunksManager = new ChunksManager(
      this.storage,
      this.pipeService,
      this.req,
      this.util
    );
    this.appProcessor = new AppProcessor(
      this.storage,
      this.pipeService,
      this.req,
      this.ws,
      this.chunksManager,
      this.util,
      options.activateSW
    );
    this.itemProcessor = new ItemProcessor(
      this.storage,
      this.pipeService,
      this.req,
      this.appProcessor,
      this.util
    );
    this.fieldProcessor = new FieldProcessor(
      this.storage,
      this.req,
      this.appProcessor,
      this.itemProcessor,
      this.pipeService
    );
    this.fileManager = new FileManager(this.storage, this.pipeService, this.req, this.appProcessor);
    this.documentManager = new DocumentManager(this.req, this.pipeService);
    this.websocketsemitter = new WebSocketEmitter(this);

    if (options.initWebsocket) {
      const gudhub = this;
      this.ws.initWebSocket(
        WebsocketHandler.bind(this, gudhub),
        this.appProcessor.refreshApps.bind(this.appProcessor)
      );
    }
    if (options.activateSW) {
      this.activateSW(options.swLink);
    }
  }

  async activateSW(swLink) {
    if (IS_WEB && "serviceWorker" in window.navigator) {
      try {
        const sw = await window.navigator.serviceWorker.register(swLink);
        sw.update()
          .then(() =>
            console.log(
              "%cSW ->>> Service worker successful updated",
              "display: inline-block ; background-color: #689f38 ; color: #ffffff ; font-weight: bold ; padding: 3px 7px; border-radius: 3px;"
            )
          )
          .catch(() => console.warn("SW ->>> Service worker is not updated"));
        console.log(
          "%cSW ->>> Service worker is registered",
          "display: inline-block ; background-color: #689f38 ; color: #ffffff ; font-weight: bold ; padding: 3px 7px; border-radius: 3px;",
          sw
        );
      } catch (error) {
        console.warn(
          "%cSW ->>> Service worker is not registered",
          "display: inline-block ; background-color: #d32f2f ; color: #ffffff ; font-weight: bold ; padding: 3px 7px; border-radius: 3px;",
          error
        );
      }
    } else {
      console.log(
        "%cSW ->>> ServiceWorkers not supported",
        "display: inline-block ; background-color: #d32f2f ; color: #ffffff ; font-weight: bold ; padding: 3px 7px; border-radius: 3px;"
      );
    }
  }

  //************************* PIPESERVICE METHODS  ****************************//
  //============= ON PIPE ===============//
  on(types, destination, fn) {
    this.pipeService.on(types, destination, fn);
    return this;
  }

  //============= EMIT PIPE ==============//
  emit(types, destination, address, params) {
    this.pipeService.emit(types, destination, address, params);
    return this;
  }

  //============ DELETE LISTENER ========//
  destroy(types, destination, func) {
    this.pipeService.destroy(types, destination, func);
    return this;
  }

  //************************* FILTERATION  ****************************//
  prefilter(filters_list, variables) {
    return this.util.prefilter(
      filters_list,
      variables
    );
  }

  //************************* WEBSOCKETS EMITTER ****************************//

  emitToUser(user_id, data) {
    return this.websocketsemitter.emitToUser(user_id, data);
  }

  broadcastToAppSubscribers(app_id, data_type, data) {
    return this.websocketsemitter.broadcastToAppSubscribers(app_id, data_type, data);
  }

  /******************* INTERPRITATE *******************/

  getInterpretation(value, field, dataType, source, itemId, appId, containerId) {
    return this.interpritate.getInterpretation(
      value,
      field,
      dataType,
      source,
      itemId,
      appId,
      containerId
    );
  }

  /******************* GET INTERPRETATION BY ID *******************/

  getInterpretationById(appId, itemId, fieldId, interpretationId, value, field) {
    return this.interpritate.getInterpretationById(appId, itemId, fieldId, interpretationId, value, field);
  }

  //============ FILTER ==========//
  filter(items, filter_list) {
    return this.util.filter(items, filter_list);
  }

  //============ MERGE FILTERS ==========//
  mergeFilters(source, destination) {
    return this.util.mergeFilters(source, destination);
  }

  //============ GROUP ==========//
  group(fieldGroup, items) {
    return this.util.group(fieldGroup, items);
  }

  //============ GET FILTERED ITEMS ==========//
  //it returns items with applyed filter
  getFilteredItems(items, filters_list, options = {}) {
    return this.util.getFilteredItems(
      items,
      filters_list,
      options.element_app_id,
      options.app_id,
      options.item_id,
      options.field_group,
      options.search,
      options.search_params
    );
  }

  sortItems(items, options) {
    return this.util.sortItems(items, options);
  }

  jsonToItems(json, map) {
    return this.util.jsonToItems(json, map);
  }

  getDate(queryKey) {
    return this.util.getDate(queryKey);
  }

  populateWithDate(items, model) {
    return this.util.populateWithDate(items, model);
  }

  checkRecurringDate(date, option) {
    return this.util.checkRecurringDate(date, option);
  }

  populateItems(items, model, keep_data) {
    return this.util.populateItems(items, model, keep_data);
  }

  populateWithItemRef(
    sourceItemsRef,
    srcFieldIdToCompare,
    destinationItems,
    destFieldIdToCompare,
    destFieldForRef,
    app_id
  ) {
    return this.util.populateWithItemRef(
      sourceItemsRef,
      srcFieldIdToCompare,
      destinationItems,
      destFieldIdToCompare,
      destFieldForRef,
      app_id
    );
  }

  compareItems(sourceItems, destinationItems, fieldToCompare) {
    return this.util.compareItems(
      sourceItems,
      destinationItems,
      fieldToCompare
    );
  }

  mergeItems(sourceItems, destinationItems, mergeByFieldId) {
    return this.util.mergeItems(sourceItems, destinationItems, mergeByFieldId);
  }

  mergeObjects(sourceObject, destinationObject) {
    return this.util.mergeObjects(sourceObject, destinationObject);
  }

  makeNestedList(arr, id, parent_id, children_property, priority_property) {
    return this.util.makeNestedList(arr, id, parent_id, children_property, priority_property);
  }

  jsonConstructor(scheme, items, variables, appId){
    return this.util.jsonConstructor(scheme, items, variables, appId)
  }

  //************************* APP PROCESSOR ****************************//
  getAppsList() {
    return this.appProcessor.getAppsList();
  }

  getAppInfo(app_id) {
    return this.appProcessor.getAppInfo(app_id);
  }

  deleteApp(app_id) {
    return this.appProcessor.deleteApp(app_id);
  }

  getApp(app_id) {
    return this.appProcessor.getApp(app_id);
  }

  updateApp(app) {
    return this.appProcessor.updateApp(app);
  }

  updateAppInfo(appInfo) {
    return this.appProcessor.updateAppInfo(appInfo);
  }

  createNewApp(app) {
    return this.appProcessor.createNewApp(app);
  }

  getItems(app_id) {
    return this.itemProcessor.getItems(app_id);
  }

  async getItem(app_id, item_id) {
    const items = await this.getItems(app_id);
    if (items) {
      return items.find((item) => item.item_id == item_id);
    }
  }

  addNewItems(app_id, itemsList) {
    return this.itemProcessor.addNewItems(app_id, itemsList);
  }

  updateItems(app_id, itemsList) {
    return this.itemProcessor.updateItems(app_id, itemsList);
  }

  deleteItems(app_id, itemsIds) {
    return this.itemProcessor.deleteItems(app_id, itemsIds);
  }

  getField(app_id, field_id) {
    return this.fieldProcessor.getField(app_id, field_id);
  }

  getFieldIdByNameSpace(app_id, name_space) {
    return this.fieldProcessor.getFieldIdByNameSpace(app_id, name_space);
  }

  getFieldModels(app_id) {
    return this.fieldProcessor.getFieldModels(app_id);
  }

  updateField(app_id, fieldModel) {
    return this.fieldProcessor.updateField(app_id, fieldModel);
  }

  deleteField(app_id, field_id) {
    return this.fieldProcessor.deleteField(app_id, field_id);
  }

  getFieldValue(app_id, item_id, field_id) {
    return this.fieldProcessor.getFieldValue(app_id, item_id, field_id);
  }

  setFieldValue(app_id, item_id, field_id, field_value) {
    return this.fieldProcessor.setFieldValue(
      app_id,
      item_id,
      field_id,
      field_value
    );
  }

  getFile(app_id, file_id) {
    return this.fileManager.getFile(app_id, file_id);
  }

  getFiles(app_id, filesId) {
    return this.fileManager.getFiles(app_id, filesId);
  }

  uploadFile(fileData, app_id, item_id) {
    return this.fileManager.uploadFile(fileData, app_id, item_id);
  }

  uploadFileFromString(
    source,
    file_name,
    app_id,
    item_id,
    extension,
    format,
    element_id
  ) {
    return this.fileManager.uploadFileFromString(
      source,
      file_name,
      app_id,
      item_id,
      extension,
      format,
      element_id
    );
  }

  updateFileFromString(data, file_id, file_name, extension, format) {
    return this.fileManager.updateFileFromString(
      data,
      file_id,
      file_name,
      extension,
      format
    );
  }

  deleteFile(app_id, id) {
    return this.fileManager.deleteFile(app_id, id);
  }

  duplicateFile(files) {
    return this.fileManager.duplicateFile(files);
  }

  downloadFileFromString(app_id, file_id) {
    return this.fileManager.downloadFileFromString(app_id, file_id);
  }

  createDocument(documentObject) {
    return this.documentManager.createDocument(documentObject);
  }

  getDocument(documentAddress) {
    return this.documentManager.getDocument(documentAddress);
  }

  getDocuments(documentAddress) {
    return this.documentManager.getDocuments(documentAddress);
  }

  deleteDocument(documentAddress) {
    return this.documentManager.deleteDocument(documentAddress);
  }

  login(data) {
    return this.auth.login(data);
  }

  logout(token) {
    this.appProcessor.clearAppProcessor();
    return this.auth.logout(token);
  }

  signup(user) {
    return this.auth.signup(user);
  }

  getUsersList(keyword) {
    return this.auth.getUsersList(keyword);
  }

  updateToken(auth_key) {
    return this.auth.updateToken(auth_key);
  }

  avatarUploadApi(image) {
    return this.auth.avatarUploadApi(image);
  }

  getVersion() {
    return this.auth.getVersion();
  }

  getUserById(userId) {
    return this.auth.getUserById(userId);
  }

  getToken() {
    return this.auth.getToken();
  }

  updateUser(userData) {
    return this.auth.updateUser(userData);
  }

  updateAvatar(imageData) {
    return this.auth.updateAvatar(imageData);
  }
}
